<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  components: {},
  props: {},
  data() {
    return {
      name: '',
      description: '',
      selectedHoneyRoles: [],
      createSuccess: false,
      generatedPersonalAccessToken: '',
      snackbarTimeout: 3000,
      copyTextBtn: false
    }
  },

  created() {
    this.getHoneyRoles()
  },

  methods: {
    async getHoneyRoles() {
      try {
        await this.$store.dispatch('fetchMyHoneyRoles')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Unable to fetch Roles',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
    },

    async create() {
      if (
        this.name !== '' &&
        this.description !== '' &&
        this.selectedHoneyRoles.length > 0
      ) {
        try {
          let response = await this.$store.dispatch('savePersonalAccessToken', {
            name: this.name,
            description: this.description,
            honeyRoles: this.selectedHoneyRoles
          })
          this.createSuccess = true
          this.generatedPersonalAccessToken = response.token
        } catch (e) {
          await this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Unable to create Personal Access Token',
            description: e.response
              ? e.response.data.message
              : 'Error unknown! Kindly retry',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      } else {
        alert('Enter the Missing Fields')
      }
    },

    backToList() {
      this.$router.replace({ name: 'personal-access-token-list' })
    },

    copyText() {
      let input = document.getElementById('patcopy')
      input.select()
      document.execCommand('copy')
    }
  },

  computed: {
    ...mapState({
      honeyRoles: state => state.honeyRoles.myHoneyRoles
    })
  }
}
</script>

<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense class="elevation-0">
          <v-tooltip bottom>
            <v-btn slot="activator" flat icon @click="backToList">
              <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
            <span>Back</span>
          </v-tooltip>
          <v-toolbar-title class="body-2"
            >Generate New Personal Access Token
          </v-toolbar-title>
          <!-- Actions icon list goes here -->
        </v-toolbar>
        <!-- Actions icon list goes here -->

        <template v-if="!createSuccess">
          <v-layout row wrap pa-4>
            <v-flex xs12 sm3>
              <v-subheader v-text="'Personal Access Token Name'"></v-subheader>
            </v-flex>
            <v-flex xs12 sm9>
              <v-text-field
                color="secondary"
                label="Personal Access Token Name"
                hint="Enter a name for the Personal Access Token"
                persistent-hint
                v-model="name"
                autofocus
              >
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm3>
              <v-subheader v-text="'Personal Access Token Description'" />
            </v-flex>
            <v-flex xs12 sm9>
              <v-text-field
                label="Personal Access Token Description"
                color="secondary"
                hint="Personal Access Token Description"
                v-model="description"
              />
            </v-flex>

            <v-flex xs12 sm3 mt-4>
              <v-subheader v-text="'Honey Roles'"></v-subheader>
            </v-flex>
            <v-flex xs12 sm9 mt-4>
              <v-autocomplete
                item-text="name"
                item-value="hexId"
                :items="honeyRoles"
                v-model="selectedHoneyRoles"
                label="Honey Roles"
                box
                return-object
                chips
                multiple
                color="secondary"
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn
                :outline="$vuetify.dark"
                @click="create"
                class="text-capitalize"
                :class="
                  $vuetify.dark
                    ? 'secondary text-capitalize'
                    : 'primary text-capitalize'
                "
                >Create Personal Access Token
              </v-btn>
            </v-layout>
          </v-card-actions>
        </template>
        <template v-else>
          <v-layout row wrap pa-4>
            <v-flex xs12 sm3>
              <v-subheader
                v-text="'Generated Personal Access Token'"
              ></v-subheader>
            </v-flex>
            <v-flex xs12 sm9>
              <v-text-field
                color="secondary"
                readonly
                solo
                v-model="generatedPersonalAccessToken"
                id="patcopy"
              >
                <template slot="append">
                  <v-tooltip bottom>
                    <v-icon
                      slot="activator"
                      @click="copyText(), (copyTextBtn = true)"
                      >file_copy
                    </v-icon>
                    <span>Copy to Clipboard</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-flex>
            <v-flex xs12 sm3></v-flex>
            <v-flex xs12 sm9>
              <v-subheader
                v-text="
                  'This Token will be generated once. Please make sure to have a track of it.'
                "
              >
              </v-subheader>
            </v-flex>
            <v-snackbar v-model="copyTextBtn" bottom :timeout="snackbarTimeout">
              Copied to Clipboard
              <v-btn flat :outline="$vuetify.dark" @click="copyTextBtn = false">
                Close
              </v-btn>
            </v-snackbar>
          </v-layout>
        </template>
      </v-card>
    </v-flex>
  </v-layout>
</template>
